import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {AfterViewInit, Directive, ViewChild} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { PersonalDetailsComponent } from '../personal-details/personal-details.component';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-student-registration-tab',
  templateUrl: './student-registration-tab.component.html',
  styleUrls: ['./student-registration-tab.component.scss']
})
export class StudentRegistrationTabComponent implements OnInit {

  selectedIndex: number = 0;

  userPermission: any;
  userType: any;
  permissionList =[];
  CustomerSettingView = true;
  UserSettingView= true;
  UserPermissionsView= true;
  isColorValue: any;
  selectedTabName: string = ''; // Add this in the parent component
  skipReservation: boolean = false;
  StudentPersonalId: any;
  constructor(public router: Router,
    private route: ActivatedRoute,
    public umsService:UmsService,
    private spinner: NgxSpinnerService,
    private change: ChangeDetectorRef) { }
    @ViewChild(PersonalDetailsComponent, {static: false}) private PersonalDetails: PersonalDetailsComponent;
  ngOnInit(): void {
    this.studentProgress();
    this.prepopulation();
   
  }
  ngAfterViewInit() {
    this.PersonalDetails.getTabName('Personal Details');
  }

  onTabChanged(event: MatTabChangeEvent) {
    console.log("On Tab Changed : ", event.tab.textLabel)
    this.selectedTabName = event.tab.textLabel; // Store the selected tab name
    if (event.tab.textLabel == "Personal Details") {
      this.selectedIndex = 0;
      this.PersonalDetails.getTabName(event.tab.textLabel);
    } else if (event.tab.textLabel == "Contact Details") {
      this.selectedIndex = 1;
    }
    else if (event.tab.textLabel == "Reservations Details") {
      this.selectedIndex = 2;
    }
    else if (event.tab.textLabel == "Additional Details") {
      this.selectedIndex = 3;
    }
    else if (event.tab.textLabel == "Qualification Details") {
      this.selectedIndex = 4;
    }
    else if (event.tab.textLabel == "Photo & Signature") {
      this.selectedIndex = 5;
    }
    else if (event.tab.textLabel == "Document Upload") {
      this.selectedIndex = 7;
    }
    else if (event.tab.textLabel == "Admission Details") {
      this.selectedIndex = 6;
    }
  }

 
public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
  this.selectedIndex = tabChangeEvent.index;
  this.studentProgress();
}

public next() {
  this.selectedIndex += 1; 
  this.studentProgress();
}
public prev(skipReservation?: boolean) {
  if (skipReservation) {
    this.selectedIndex -= 2;
  } else {
    this.selectedIndex -= 1;
    this.studentProgress();
  }
  
}

public jump() {
  this.selectedIndex = 3; 
  this.studentProgress();
}
public first() { 
  this.selectedIndex = 0;
  this.studentProgress();
}

// public enable(){
//   this.umsService.disable = false;
// }

ngOnChanges(changes: StudentRegistrationTabComponent) {
}
redirect(to): void {
  this.router.navigate([to]);
}  

getScrutiny(studentId) {
  const studentPersonalId = sessionStorage.getItem('StudentPersonalId');
  if (!studentPersonalId) {
    return;
  }
  const payload = { 'StudentId': studentId };
 
  this.umsService.fetchScrutinyLock(payload).subscribe(
    res => {
      this.spinner.hide();
      if (res.data && res.data.length > 0) {
        this.isColorValue = res.data[0].Tabs;
        this.spinner.hide();
      } else {
      this.spinner.hide();
      }
    },
    error => {
      this.spinner.hide();
    }
  );
}

prepopulation() {
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.StudentPersonalId = res.data[0].StuId
          this.getScrutiny(res.data[0].StuId);
        } else {
          
        }
        
      } else {
        
        
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide()
     
        this.spinner.hide();
    })
  }
  prepopulationContact() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchContactDetails(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
        }
      } 
    }, (ERROR: HttpErrorResponse) => {
      
    })

  }
studentProgress() {
  const studentPersonalId = sessionStorage.getItem('StudentRGID');
  if (!studentPersonalId) {
    return;
  }
  const payload = { 'StuRgNo': studentPersonalId };
  this.umsService.fetchStudentProgress(payload).subscribe(
    res => {
      this.spinner.hide();
      if (res.data && res.data.length > 0) {
      this.umsService.studentProgressList = res.data[0];
      console.log("this.umsService.studentProgressList",this.umsService.studentProgressList)
      } else {
        let dd =  [{
          "StudentPersonal": 0,
          "StudentAddress": 1,
          "StudentReservation": 1,
          "StudentAdditionalDetails": 1,
          "StudentQualification": 1,
          "StudentPhotoAndSign": 1,
          "StudentAdmissinDetails": 1,
          "StudentuploadDocument": 1
        }];
        this.umsService.studentProgressList = dd[0]
      console.log("this.umsService.studentProgressList",this.umsService.studentProgressList)
      }
    },
    error => {
      this.spinner.hide();
      let dd =  [{
        "StudentPersonal": 0,
        "StudentAddress": 1,
        "StudentReservation": 1,
        "StudentAdditionalDetails": 1,
        "StudentQualification": 1,
        "StudentPhotoAndSign": 1,
        "StudentAdmissinDetails": 1,
        "StudentuploadDocument": 1
      }];
      this.umsService.studentProgressList = dd[0]
    }
  );
}

 
checkcolor(tabLabel, id): any {
  if (this.isColorValue && this.isColorValue.includes(tabLabel)) {
    var element = document.getElementById(id);
    if (element) {
      element.style.backgroundColor = "red";
      element.style.color = "white";
    }
  }
}
}